import React from 'react';
import type { PropertyStatus } from '../../types/cms';
import { statusLabels, statusBadgeClasses } from '../../utils/helpers';

interface PropertyStatusBadgeProps {
  status?: PropertyStatus;
  className?: string;
  pulse?: boolean;
}

export const PropertyStatusBadge: React.FC<PropertyStatusBadgeProps> = ({
  status = 'available',
  className = '',
  pulse = true,
}) => {
  if (status === 'available') return null;
  return (
    <span
      className={`rounded-md px-2.5 py-1 text-[11px] font-bold text-white shadow-sm ${
        pulse ? 'animate-pulse-slow' : ''
      } ${statusBadgeClasses[status]} ${className}`}
    >
      {statusLabels[status]}
    </span>
  );
};

export default PropertyStatusBadge;
